import { useRef as u, useEffect as o } from "react";
const l = (r, t, e) => {
  const n = u(() => {
  }), c = u(null);
  o(() => {
    n.current = r;
  }, [r]), o(() => {
    function s() {
      n.current();
    }
    return e ? () => {
    } : (c.current = setInterval(s, t), () => clearInterval(c.current));
  }, [t, e]);
};
export {
  l as useInterval
};
//# sourceMappingURL=index.es845.js.map
